(function traceZeroThemeRain() {
  if (window.NewDawnTraceZeroRain) {
    window.NewDawnTraceZeroRain.hydrateRainNodes(document);
    return;
  }

  const RAIN_LAYER_CONFIGS = [
    {
      className: 'tz-rain-field-primary',
      count: 42,
      mobileCount: 24,
      motionScale: 1,
      widthOptions: ['1px', '2px', '2px', '3px'],
      topRange: [-64, -6],
      heightRange: [20, 38],
      durationRange: [1.2, 1.7],
      opacityRange: [0.44, 0.68],
    },
    {
      className: 'tz-rain-field-secondary',
      count: 36,
      mobileCount: 20,
      motionScale: 0.78,
      widthOptions: ['1px', '1px', '2px', '2px'],
      topRange: [-60, -4],
      heightRange: [16, 30],
      durationRange: [1.45, 2.05],
      opacityRange: [0.3, 0.48],
    },
    {
      className: 'tz-rain-field-tertiary',
      count: 36,
      mobileCount: 18,
      motionScale: 0.56,
      widthOptions: ['1px', '1px', '1px', '2px'],
      topRange: [-48, -2],
      heightRange: [12, 22],
      durationRange: [1.75, 2.4],
      opacityRange: [0.16, 0.28],
    },
  ];

  const RAIN_TIMING_OPTIONS = [
    'cubic-bezier(0.24, 0.08, 0.32, 1)',
    'cubic-bezier(0.22, 0.1, 0.28, 1)',
    'cubic-bezier(0.3, 0.06, 0.34, 1)',
    'cubic-bezier(0.2, 0.1, 0.26, 1)',
  ];

  const RAIN_VIEWPORT_CONFIGS = {
    desktop: {
      countScale: 1,
      heightScale: 1,
      topScale: 1,
      durationScale: 1,
      leftRange: [-3, 101],
      streakDirectionBias: 0.72,
      motionDriftScale: 1,
      horizontalDistribution: 'random',
      windBaseAngleRange: [5.1, 7.2],
      windBaseDriftRange: [12, 18],
      windMidAngleOffsetRange: [1.4, 2.8],
      windMidDriftOffsetRange: [5, 9],
      windSettleAngleOffsetRange: [0.35, 1.2],
      windSettleDriftOffsetRange: [1.5, 4.5],
      windCycleDurationRange: [9.4, 10.8],
    },
    tablet: {
      countScale: 0.8,
      heightScale: 0.84,
      topScale: 0.86,
      durationScale: 0.94,
      leftRange: [-4, 102],
      streakDirectionBias: 0.62,
      motionDriftScale: 0.88,
      horizontalDistribution: 'random',
      windBaseAngleRange: [4.2, 6.1],
      windBaseDriftRange: [10, 15],
      windMidAngleOffsetRange: [1.1, 2.2],
      windMidDriftOffsetRange: [4, 7],
      windSettleAngleOffsetRange: [0.3, 1],
      windSettleDriftOffsetRange: [1.2, 3.2],
      windCycleDurationRange: [9.1, 10.4],
    },
    mobile: {
      countScale: 0.68,
      heightScale: 0.68,
      topScale: 0.74,
      durationScale: 0.92,
      leftRange: [-8, 106],
      streakDirectionBias: 0.5,
      motionDriftScale: 0.68,
      horizontalDistribution: 'stratified',
      windBaseAngleRange: [2.6, 4.1],
      windBaseDriftRange: [5.5, 8.5],
      windMidAngleOffsetRange: [0.7, 1.35],
      windMidDriftOffsetRange: [2.2, 4.1],
      windSettleAngleOffsetRange: [0.18, 0.6],
      windSettleDriftOffsetRange: [0.8, 2],
      windCycleDurationRange: [8.8, 10.1],
    },
  };

  const RAIN_CONTEXT_CONFIGS = {
    page: { countScale: 1.22, opacityScale: 1.04 },
    shell: { countScale: 1, opacityScale: 1 },
    section: { countScale: 0.92, opacityScale: 0.9 },
    panel: { countScale: 0.84, opacityScale: 0.86 },
    portal: { countScale: 0.68, opacityScale: 0.78 },
    card: { countScale: 0.52, opacityScale: 0.7 },
  };

  let currentViewportMode = getViewportMode();
  let resizeFrame = null;

  function randomBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function randomSigned(min, max) {
    return randomBetween(min, max) * (Math.random() < 0.5 ? -1 : 1);
  }

  function pickRandom(values) {
    return values[Math.floor(Math.random() * values.length)];
  }

  function formatRainValue(value, unit) {
    return `${value.toFixed(2)}${unit}`;
  }

  function formatRainNumber(value) {
    return value.toFixed(3);
  }

  function scaleRange(range, scale) {
    return [range[0] * scale, range[1] * scale];
  }

  function withSharedDirection(range, direction) {
    return range.map((value) => value * direction);
  }

  function clampNumber(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function createRainLeftPosition(index, count, viewportConfig) {
    const [leftMin, leftMax] = viewportConfig.leftRange || [-3, 101];

    if (viewportConfig.horizontalDistribution === 'stratified') {
      const segmentWidth = (leftMax - leftMin) / count;
      const segmentStart = leftMin + segmentWidth * index;
      const jitter = segmentWidth * 0.22;
      const left = clampNumber(
        randomBetween(segmentStart, segmentStart + segmentWidth) +
          randomSigned(0, jitter),
        leftMin,
        leftMax,
      );

      return formatRainValue(left, '%');
    }

    return formatRainValue(randomBetween(leftMin, leftMax), '%');
  }

  function getViewportMode() {
    if (window.matchMedia('(max-width: 640px)').matches) return 'mobile';
    if (window.matchMedia('(max-width: 860px)').matches) return 'tablet';
    return 'desktop';
  }

  function createRainWind(viewportConfig) {
    const direction = Math.random() < 0.5 ? -1 : 1;
    const cycleDuration = randomBetween(...viewportConfig.windCycleDurationRange);
    const baseAngle = randomBetween(
      ...withSharedDirection(viewportConfig.windBaseAngleRange, direction),
    );
    const baseDrift = randomBetween(
      ...withSharedDirection(viewportConfig.windBaseDriftRange, direction),
    );
    const midAngle =
      baseAngle +
      randomBetween(
        ...withSharedDirection(viewportConfig.windMidAngleOffsetRange, direction),
      );
    const midDrift =
      baseDrift +
      randomBetween(
        ...withSharedDirection(viewportConfig.windMidDriftOffsetRange, direction),
      );
    const settleAngle =
      baseAngle +
      randomBetween(
        ...withSharedDirection(
          viewportConfig.windSettleAngleOffsetRange,
          direction,
        ),
      );
    const settleDrift =
      baseDrift +
      randomBetween(
        ...withSharedDirection(
          viewportConfig.windSettleDriftOffsetRange,
          direction,
        ),
      );

    return {
      baseAngle,
      baseDrift,
      midAngle,
      midDrift,
      settleAngle,
      settleDrift,
      cycleDuration,
      cycleDelay: -randomBetween(0, cycleDuration),
    };
  }

  function createRainMotionProfile(config, viewportConfig) {
    const motionScale =
      (config.motionScale || 1) * (viewportConfig.motionDriftScale || 1);
    const driftDirection =
      Math.random() < (viewportConfig.streakDirectionBias || 0.72) ? 1 : -1;
    const xStart = randomSigned(0, 2.4 * motionScale);
    const xEarly =
      xStart +
      randomBetween(0.8, 3.2) * driftDirection * motionScale +
      randomSigned(0, 1.2 * motionScale);
    const xMid =
      xEarly +
      randomBetween(1.4, 4.8) * driftDirection * motionScale +
      randomSigned(0.2, 1.8 * motionScale);
    const xLate =
      xMid +
      randomBetween(0.8, 3.4) * driftDirection * motionScale +
      randomSigned(0.2, 1.9 * motionScale);
    const xEnd =
      xLate +
      randomBetween(0.6, 2.3) * driftDirection * motionScale +
      randomSigned(0.1, 1.4 * motionScale);

    const tiltStart = randomSigned(0, 0.5 * motionScale);
    const tiltEarly = clampNumber(
      tiltStart +
        randomBetween(0.2, 0.9) * driftDirection * motionScale +
        randomSigned(0, 0.25 * motionScale),
      -3.2,
      3.2,
    );
    const tiltMid = clampNumber(
      tiltEarly + randomSigned(0.1, 0.7 * motionScale),
      -3.6,
      3.6,
    );
    const tiltLate = clampNumber(
      tiltMid + randomSigned(0.08, 0.6 * motionScale),
      -3.6,
      3.6,
    );
    const tiltEnd = clampNumber(
      tiltLate + randomSigned(0.08, 0.45 * motionScale),
      -3.2,
      3.2,
    );

    return {
      xStart: formatRainValue(xStart, 'px'),
      xEarly: formatRainValue(xEarly, 'px'),
      xMid: formatRainValue(xMid, 'px'),
      xLate: formatRainValue(xLate, 'px'),
      xEnd: formatRainValue(xEnd, 'px'),
      yEarly: formatRainValue(randomBetween(-96, -64), '%'),
      yMid: formatRainValue(randomBetween(18, 48), '%'),
      yLate: formatRainValue(randomBetween(116, 150), '%'),
      yEnd: formatRainValue(randomBetween(196, 236), '%'),
      tiltStart: formatRainValue(tiltStart, 'deg'),
      tiltEarly: formatRainValue(tiltEarly, 'deg'),
      tiltMid: formatRainValue(tiltMid, 'deg'),
      tiltLate: formatRainValue(tiltLate, 'deg'),
      tiltEnd: formatRainValue(tiltEnd, 'deg'),
      scaleStart: formatRainNumber(randomBetween(0.78, 0.86)),
      scaleEarly: formatRainNumber(randomBetween(0.88, 0.94)),
      scaleMid: formatRainNumber(randomBetween(0.96, 1.01)),
      scaleLate: formatRainNumber(randomBetween(1, 1.05)),
      scaleEnd: formatRainNumber(randomBetween(1.02, 1.08)),
      opacityEarly: formatRainNumber(randomBetween(0.64, 0.9)),
      opacityPulse: formatRainNumber(randomBetween(0.94, 1.08)),
      opacityLate: formatRainNumber(randomBetween(0.66, 0.86)),
      timing: pickRandom(RAIN_TIMING_OPTIONS),
    };
  }

  function createRainLayer(config, viewportConfig, viewportMode, contextConfig) {
    const baseCount =
      viewportMode === 'mobile' && config.mobileCount
        ? config.mobileCount
        : Math.max(1, Math.round(config.count * viewportConfig.countScale));
    const count = Math.max(
      1,
      Math.round(baseCount * (contextConfig.countScale || 1)),
    );
    const heightRange = scaleRange(config.heightRange, viewportConfig.heightScale);
    const topRange = scaleRange(config.topRange, viewportConfig.topScale);
    const durationRange = scaleRange(
      config.durationRange,
      viewportConfig.durationScale,
    );

    return Array.from({ length: count }, (_, index) => {
      const duration = randomBetween(...durationRange);
      const motion = createRainMotionProfile(config, viewportConfig);
      const opacity = clampNumber(
        randomBetween(...config.opacityRange) * (contextConfig.opacityScale || 1),
        0.08,
        1,
      );

      return {
        left: createRainLeftPosition(index, count, viewportConfig),
        top: formatRainValue(randomBetween(...topRange), '%'),
        width: pickRandom(config.widthOptions),
        height: formatRainValue(randomBetween(...heightRange), '%'),
        duration: formatRainValue(duration, 's'),
        delay: formatRainValue(-randomBetween(0, duration), 's'),
        opacity: opacity.toFixed(2),
        xStart: motion.xStart,
        xEarly: motion.xEarly,
        xMid: motion.xMid,
        xLate: motion.xLate,
        xEnd: motion.xEnd,
        yEarly: motion.yEarly,
        yMid: motion.yMid,
        yLate: motion.yLate,
        yEnd: motion.yEnd,
        tiltStart: motion.tiltStart,
        tiltEarly: motion.tiltEarly,
        tiltMid: motion.tiltMid,
        tiltLate: motion.tiltLate,
        tiltEnd: motion.tiltEnd,
        scaleStart: motion.scaleStart,
        scaleEarly: motion.scaleEarly,
        scaleMid: motion.scaleMid,
        scaleLate: motion.scaleLate,
        scaleEnd: motion.scaleEnd,
        opacityEarly: motion.opacityEarly,
        opacityPulse: motion.opacityPulse,
        opacityLate: motion.opacityLate,
        timing: motion.timing,
      };
    });
  }

  function createRainSceneRuns(
    viewportMode = getViewportMode(),
    contextConfig = RAIN_CONTEXT_CONFIGS.shell,
  ) {
    const viewportConfig =
      RAIN_VIEWPORT_CONFIGS[viewportMode] || RAIN_VIEWPORT_CONFIGS.desktop;

    return {
      wind: createRainWind(viewportConfig),
      layers: RAIN_LAYER_CONFIGS.map((config) => ({
        className: config.className,
        streaks: createRainLayer(
          config,
          viewportConfig,
          viewportMode,
          contextConfig,
        ),
      })),
    };
  }

  function renderRainLayer(streaks, className) {
    return `
      <div class="tz-rain-field ${className}">
        ${streaks
          .map(
            (streak) => `
              <span
                class="tz-rain-streak"
                style="--tz-rain-left:${streak.left}; --tz-rain-top:${streak.top}; --tz-rain-width:${streak.width}; --tz-rain-height:${streak.height}; --tz-rain-duration:${streak.duration}; --tz-rain-delay:${streak.delay}; --tz-rain-opacity:${streak.opacity}; --tz-rain-x-start:${streak.xStart}; --tz-rain-x-early:${streak.xEarly}; --tz-rain-x-mid:${streak.xMid}; --tz-rain-x-late:${streak.xLate}; --tz-rain-x-end:${streak.xEnd}; --tz-rain-y-early:${streak.yEarly}; --tz-rain-y-mid:${streak.yMid}; --tz-rain-y-late:${streak.yLate}; --tz-rain-y-end:${streak.yEnd}; --tz-rain-tilt-start:${streak.tiltStart}; --tz-rain-tilt-early:${streak.tiltEarly}; --tz-rain-tilt-mid:${streak.tiltMid}; --tz-rain-tilt-late:${streak.tiltLate}; --tz-rain-tilt-end:${streak.tiltEnd}; --tz-rain-scale-start:${streak.scaleStart}; --tz-rain-scale-early:${streak.scaleEarly}; --tz-rain-scale-mid:${streak.scaleMid}; --tz-rain-scale-late:${streak.scaleLate}; --tz-rain-scale-end:${streak.scaleEnd}; --tz-rain-opacity-early:${streak.opacityEarly}; --tz-rain-opacity-pulse:${streak.opacityPulse}; --tz-rain-opacity-late:${streak.opacityLate}; --tz-rain-timing:${streak.timing};"
              ></span>
            `,
          )
          .join('')}
      </div>
    `;
  }

  function renderRainScene(scene) {
    return `
      <div
        class="tz-atmosphere"
        aria-hidden="true"
        style="--tz-wind-angle-base:${formatRainValue(scene.wind.baseAngle, 'deg')}; --tz-wind-angle-mid:${formatRainValue(scene.wind.midAngle, 'deg')}; --tz-wind-angle-settle:${formatRainValue(scene.wind.settleAngle, 'deg')}; --tz-wind-drift-base:${formatRainValue(scene.wind.baseDrift, 'px')}; --tz-wind-drift-mid:${formatRainValue(scene.wind.midDrift, 'px')}; --tz-wind-drift-settle:${formatRainValue(scene.wind.settleDrift, 'px')}; --tz-wind-cycle-duration:${formatRainValue(scene.wind.cycleDuration, 's')}; --tz-wind-cycle-delay:${formatRainValue(scene.wind.cycleDelay, 's')};"
      >
        <div class="tz-rain-depth"></div>
        <div class="tz-rain-glow"></div>
        ${scene.layers
          .map((layer) => renderRainLayer(layer.streaks, layer.className))
          .join('')}
      </div>
    `;
  }

  function getContextConfig(node) {
    const context = node.dataset.traceZeroRainContext || 'shell';
    return RAIN_CONTEXT_CONFIGS[context] || RAIN_CONTEXT_CONFIGS.shell;
  }

  function hydrateRainNode(node) {
    const contextConfig = getContextConfig(node);
    const scene = createRainSceneRuns(currentViewportMode, contextConfig);

    node.innerHTML = renderRainScene(scene);
    node.dataset.traceZeroRainReady = 'true';
  }

  function collectRainNodes(root) {
    const nodes = [];

    if (root && root.nodeType === 1 && root.matches('[data-trace-zero-rain]')) {
      nodes.push(root);
    }

    const scopedRoot = root && root.querySelectorAll ? root : document;
    scopedRoot.querySelectorAll('[data-trace-zero-rain]').forEach((node) => {
      nodes.push(node);
    });

    return nodes;
  }

  function hydrateRainNodes(root) {
    collectRainNodes(root).forEach((node) => {
      if (node.isConnected) {
        hydrateRainNode(node);
      }
    });
  }

  function handleViewportChange() {
    const nextViewportMode = getViewportMode();

    if (nextViewportMode === currentViewportMode) {
      return;
    }

    currentViewportMode = nextViewportMode;
    hydrateRainNodes(document);
  }

  function scheduleViewportCheck() {
    if (resizeFrame) {
      window.cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = window.requestAnimationFrame(() => {
      resizeFrame = null;
      handleViewportChange();
    });
  }

  window.addEventListener('resize', scheduleViewportCheck, { passive: true });
  document.addEventListener('shopify:section:load', (event) => {
    hydrateRainNodes(event.target);
  });

  window.NewDawnTraceZeroRain = {
    hydrateRainNodes,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrateRainNodes(document), {
      once: true,
    });
  } else {
    hydrateRainNodes(document);
  }
})();
